'use client'

import clsx from 'clsx'
import { type ComponentProps } from 'react'
import { type ResponsiveLevel } from 'ui/src/theme/media'
import { root, rootPadded, contentStatic, contentDynamic } from './GridLayout.css'
import type { ContentAlignment, ColumnWidth, ContentWidth } from './GridLayout.types'

export function Root({ className, nested, ...others }: ComponentProps<'div'> & { nested?: boolean }) {
  return <div className={clsx(root, !nested && rootPadded, className)} {...others} />
}

type ContentProps = {
  width: ContentWidth
  align?: ContentAlignment
}

export function Content({ className, width, align = 'left', ...others }: ComponentProps<'div'> & ContentProps) {
  const classList = typeof width === 'object' ? contentDynamic(normalizeWidth(width)) : contentStatic[width]

  return <div className={clsx(classList, className)} data-alignment={align} {...others} />
}

// This is a safety measure. We're gonna be able to remove this one we update
// Storyblok "layout" plugin so it uses '_' instead 'base'
function normalizeWidth(width: ContentWidth) {
  if (typeof width === 'string') return width

  return Object.keys(width).reduce(
    (acc, level) => {
      if (level === 'base') return { ...acc, _: width.base }

      return { ...acc, [level]: width[level as ResponsiveLevel] }
    },
    {} as Partial<Record<ResponsiveLevel, ColumnWidth>>,
  )
}
